<template>
    <div
        class="gcmcn-card gcmcn-card-dashboard"
        style="padding: 0;"
    >
        <taker-card
            :taker="taker"
            :selected-taker-uid="''"
            :display-actions="false"
            style="padding-bottom: 0;"
        ></taker-card>
        <div class="dashboard-see-more" @click="showTaker">
            <i class="el-icon-view"></i>
            <span>SEE MORE</span>
        </div>
    </div>
</template>

<script>
import TakerCard from '../Takers/takerCard.vue';
export default {

    components: {
        TakerCard,
    },

    props: {
        taker: {
            type: Object,
            required: true
        },
    },

    data (){
        return {

        };
    },

    computed: {

    },

    mounted (){

    },

    methods: {
        showTaker (){
            this.$router.push({
                name: 'takers',
                params: {
                    takerUid: this.taker.uid,
                },
            });
        }
    },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/page/Home/taker-card.vue